import { DefaultService } from '@/services/DefaultService';

export default class LgpdSobreService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    getSobreAtivo() {
        return this._http.get(`${this._env}/lgpd/sobre.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    
}